import { render } from "./AllBusinessList.vue?vue&type=template&id=dcadaa20&scoped=true"
import script from "./AllBusinessList.vue?vue&type=script&lang=js"
export * from "./AllBusinessList.vue?vue&type=script&lang=js"

import "./AllBusinessList.vue?vue&type=style&index=0&id=dcadaa20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcadaa20"]])

export default __exports__